import { QUIZ } from './sectionType'

export const INTRO = {
  [QUIZ]: 'You will only have one try at answering each question in the quizzes. Reach out to your instructor to understand how these contribute to your grades.'
}
